import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { SafeAreaPlugin } from './definitions';
import { CAPACITOR_SAFE_AREA_PLUGIN } from '../pluginConstants';

const SafeAreaRaw = registerPlugin<SafeAreaPlugin>(CAPACITOR_SAFE_AREA_PLUGIN);
const SafeArea = withBridgedStackTrace(SafeAreaRaw, 'SafeArea');

export * from './definitions';
export { SafeArea };
